"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRewardAuth = exports.getTokenEscrow = exports.getStakingVarsAccount = exports.getStakingAccountsForRegisteredStake = exports.getStakingAccount = exports.getRegisteredStake = void 0;
const anchor_1 = require("@project-serum/anchor");
const web3_js_1 = require("@solana/web3.js");
const utils_1 = require("../utils");
const seeds_1 = require("./seeds");
/**
 * Returns the public key and bump seed for a registered stake account
 * */
function getRegisteredStake(programId, authority, stakeToken, rewardToken) {
    return __awaiter(this, void 0, void 0, function* () {
        return web3_js_1.PublicKey.findProgramAddress([
            seeds_1.REGISTERED_STAKE,
            authority.toBuffer(),
            stakeToken.toBuffer(),
            rewardToken.toBuffer(),
        ], programId);
    });
}
exports.getRegisteredStake = getRegisteredStake;
/**
 * Returns the public key and bump seed for a staking account
 * */
function getStakingAccount(programId, user, registeredStake) {
    return __awaiter(this, void 0, void 0, function* () {
        return web3_js_1.PublicKey.findProgramAddress([seeds_1.STAKING_ACCOUNT, user.toBuffer(), registeredStake.toBuffer()], programId);
    });
}
exports.getStakingAccount = getStakingAccount;
function getStakingAccountsForRegisteredStake(connection, programId, registeredStake) {
    return __awaiter(this, void 0, void 0, function* () {
        const provider = new anchor_1.AnchorProvider(connection, null, null);
        const idl = (0, utils_1.getStakingIdl)(programId);
        const program = new anchor_1.Program(idl, programId, provider);
        const filter = [
            {
                dataSize: 171,
            },
            {
                memcmp: {
                    offset: 40,
                    bytes: registeredStake.toBase58(),
                },
            },
        ];
        const stakingAccounts = yield program.account.stakingAccount.all(filter);
        return stakingAccounts;
    });
}
exports.getStakingAccountsForRegisteredStake = getStakingAccountsForRegisteredStake;
/**
 * Returns the public key and bump seed for the staking program variables account
 *
 * @param programId - Deployed program ID for the Staking Program
 */
function getStakingVarsAccount(programId) {
    return __awaiter(this, void 0, void 0, function* () {
        return web3_js_1.PublicKey.findProgramAddress([seeds_1.STAKING_VARS], programId);
    });
}
exports.getStakingVarsAccount = getStakingVarsAccount;
/**
 * Returns the public key and bump seed for a user's token escrow
 * */
function getTokenEscrow(programId, user, registeredStake) {
    return __awaiter(this, void 0, void 0, function* () {
        return web3_js_1.PublicKey.findProgramAddress([seeds_1.STAKING_ESCROW, user.toBuffer(), registeredStake.toBuffer()], programId);
    });
}
exports.getTokenEscrow = getTokenEscrow;
/**
 * Returns the public key and bump seed for a registered stake's reward vault authority
 * */
function getRewardAuth(programId, registeredStake) {
    return __awaiter(this, void 0, void 0, function* () {
        return web3_js_1.PublicKey.findProgramAddress([seeds_1.REWARD_AUTH, registeredStake.toBuffer()], programId);
    });
}
exports.getRewardAuth = getRewardAuth;
//# sourceMappingURL=pda_getters.js.map